import * as React from 'react';
import { styled } from '@glitz/react';
import Item from 'webapp/shell/main-menu/Item';
import { bareListDecorator } from 'webapp/decorators/list';
import { type MenuItemsOrItemType } from './Nav';
import { translate } from '@avensia/excite';
import { itemKey } from 'webapp/shell/main-menu/helpers';
import { TabsType } from 'webapp/shell/main-menu/Tabs';
import { isSvenssons } from 'webapp/theme';
import { overflowYDecorator } from 'webapp/decorators/overflow';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';

export function isRoot(data: MenuItemsOrItemType): data is NordicNest.Api.MenuItemApiModel[] {
  return Array.isArray(data);
}

type PropType = {
  data: MenuItemsOrItemType;
  pushLevel?: (item: NordicNest.Api.MenuItemApiModel) => void;
  selectedItemKey?: string;
  children?: React.ReactNode;
  selectedTab?: TabsType;
};

export const Level = React.forwardRef<HTMLUListElement, PropType>((props, ref) => {
  const { data, pushLevel } = props;
  const root = isRoot(data);
  const items = root ? data : data?.childPages || [];

  if (data === null || data === undefined) {
    return null;
  }

  const showBorder = Boolean(isSvenssons || (!isSvenssons && props.selectedTab === TabsType.Products));

  return (
    <List ref={ref}>
      {!root && (
        <RootItem css={showBorder && borderDecorator}>
          <Item
            linkText={translate(t => t.mobileMenu.showAll) + ' ' + data.link.children}
            key={itemKey(data)}
            item={data}
            navigationData={{
              menu_category: 'mobile',
              menu_type: props.selectedTab === TabsType.Products ? 'main' : 'secondary',
            }}
          />
        </RootItem>
      )}
      {items.map(item => (
        <ListItem key={itemKey(item)} css={showBorder && borderDecorator}>
          <Item
            key={itemKey(item)}
            item={item}
            pushLevel={pushLevel}
            navigationData={{
              menu_category: 'mobile',
              menu_type: props.selectedTab === TabsType.Products ? 'main' : 'secondary',
            }}
          />
        </ListItem>
      ))}
      {props.children}
    </List>
  );
});

const List = styled.ul(bareListDecorator, overflowYDecorator);

const ListItem = styled.li();

const RootItem = styled(
  ListItem,
  isSvenssons && {
    fontWeight: 700,
  },
);

const borderDecorator = styled(
  createMaxSmallViewportDecorator({
    border: {
      bottom: { color: t => t.mobileMenu?.borderColor, width: 1, style: 'solid' },
    },
  }),
);
